/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for PaymentModeResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetPaymentModesResponse, GetPaymentModeSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class PaymentModeResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getPaymentModes(searchTerm: Signal<string | null | undefined> | string | null | undefined, resourceOptions: HttpResourceOptions<GetPaymentModesResponse, unknown> & { defaultValue: NoInfer<GetPaymentModesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPaymentModesResponse>;
    getPaymentModes(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetPaymentModesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPaymentModesResponse | undefined>;
    getPaymentModes(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetPaymentModesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPaymentModesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            return {
                url: `${this.basePath}/PaymentMode`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getPaymentModeSelect(resourceOptions: HttpResourceOptions<GetPaymentModeSelectResponse, unknown> & { defaultValue: NoInfer<GetPaymentModeSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPaymentModeSelectResponse>;
    getPaymentModeSelect(resourceOptions?: HttpResourceOptions<GetPaymentModeSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPaymentModeSelectResponse | undefined>;
    getPaymentModeSelect(resourceOptions?: HttpResourceOptions<GetPaymentModeSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPaymentModeSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/PaymentMode/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
